"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeReAttachType = void 0;
var HomeReAttachType;
(function (HomeReAttachType) {
    HomeReAttachType["SAME_HOME"] = "SAME_HOME";
    HomeReAttachType["DIFFERENT_HOME"] = "DIFFERENT_HOME";
    HomeReAttachType["CREDIT_LINE_INCREASE"] = "CREDIT_LINE_INCREASE";
    HomeReAttachType["CREDIT_LINE_INCREASE_DRYRUN"] = "CREDIT_LINE_INCREASE_DRYRUN";
    HomeReAttachType["APR_REDUCTION"] = "APR_REDUCTION";
})(HomeReAttachType || (exports.HomeReAttachType = HomeReAttachType = {}));
